/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M17.8106 12.4983a.7502.7502 0 0 0-1.1212-.9966l-5.4211 6.0988-3.1921-3.8306a.75.75 0 0 0-1.1524.9602l4.3079 5.1694 6.5789-7.4012Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.75 5.25C6.75 2.3505 9.1005 0 12 0s5.25 2.3505 5.25 5.25V6h3.0953c.7501 0 1.3849.5541 1.4863 1.2973l1.8132 13.2974C23.8905 22.3959 22.4903 24 20.6724 24H3.3276c-1.818 0-3.218-1.6041-2.9725-3.4053L2.1684 7.2973A1.5 1.5 0 0 1 3.6547 6H6.75v-.75Zm9 3V7.5h-7.5v.75a.75.75 0 0 1-1.5 0V7.5H3.6547L1.8414 20.7973c-.1228.9007.5773 1.7027 1.4862 1.7027h17.3448c.9089 0 1.609-.802 1.4862-1.7027L20.3453 7.5H17.25v.75a.75.75 0 0 1-1.5 0Zm0-3V6h-7.5v-.75C8.25 3.179 9.929 1.5 12 1.5c2.0711 0 3.75 1.679 3.75 3.75Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'AddedMarketPlace'
);
